const img = require('./PcVerticalTri.svg'); export default img;